import { useTranslate } from '@ur-solutions/react-hooks'
import { AbsenceReportPerUserCard } from '../components/AbsenceSettings/absence-report-user-card'
import { ExportSection } from '../components/ExportsSettings/components'

export function AbsenceReport() {
  const translations = useTranslate({
    header: 'settings.absence.reports.menu-title',
  })

  return (
    <ExportSection header={translations.header}>
      <AbsenceReportPerUserCard />
    </ExportSection>
  )
}
